// Vendors
import $ from 'jquery';

const listContainer = '.segmented-list';
const gridContainer = '.segmented-list--grid';
const filterClass = '.segmented-list--filter';
let num_hits = 0;

$(function () {
  $(filterClass).first().click();
});

$(window).resize(function () {
  resizeColumns(num_hits);
});

$(filterClass).on('click', event => {
  event.preventDefault();
  $(filterClass).removeClass('active');
  const filter = $(event.currentTarget).data('toggle');
  $(event.currentTarget).addClass('active');
  ajaxQueryBapMembers(filter);
});

function resizeColumns(hits) {
  let width = $(window).width();
  let columns = 3;
  if (width < 576) {
    columns = 1;
  } else if (width < 768) {
    columns = 2;
  }
  let num_rows = Math.ceil((hits / columns));
  $(gridContainer).css({ 'grid-template-columns': `repeat(${columns}, 1fr)`, 'grid-template-rows': `repeat(${num_rows}, 1fr)` });
}

function ajaxQueryBapMembers(filter) {
  const domain = document.domain;
  let url = '/wp/wp-admin/admin-ajax.php?action=post_ajax_get_post_types';
  if (domain === 'texas-ec.org') {
    url = '/wp-admin/admin-ajax.php?action=post_ajax_get_post_types';
  }

  $.ajax({
    type: 'POST',
    url: url,
    data: { 'filter': filter, 'post_type': $(listContainer).data('type') },
    dataType: 'json',
    success: res => {
      let output = '';
      num_hits = res.data.hits_count;
      if (res.data.hits.length) {
        res.data.hits.forEach((post, index) => {
          output += '<div class="segmented-list--grid-col">';
          output += '<article class="card--member">';
          output += '<div class="card__body">';

          if (post.url) {
            output += `<a class="card__title" href="${post.url}">${post.title}</a>`;
          } else {
            output += `<p class="card__title">${post.title}</p>`;
          }

          if (post.address) {
            output += `<address class="card__address">${post.address}</address>`;
          } else {
            output += `<address class="card__address">610 E. American Blvd., Muleshoe, TX 79347</address>`;
          }

          if (post.phone) {
            output += `<p class="card__phone">${post.phone}</p>`;
          } else {
            output += `<p class="card__phone">(806) 272-4504</p>`;
          }
          output += '</div>';
          output += '</article>';
          output += '</div>';
        });
      } else {
        output =
          '<h5>No results found...</h5>';
      }

      resizeColumns(num_hits);
      $(gridContainer).empty();
      $(gridContainer).append(output);
    },
    error: res => {
      $(gridContainer).empty();
      $(gridContainer).append(
        '<h5>There was an error fetching the results.</h5>'
      );
    }
  });
}
